<template>

    <div>
        
        <div v-if="result.success">
            <p>{{$t('group.import.please_check_the_following_carefully_the_import_of_this_data_cannot_be_undone')}}</p>

            <table class="table">
                <tr>
                    <th>#</th>
                    <th colspan="2">{{$t('group.import.students')}}</th>
                    <th colspan="2" v-if="settings.teacher_email">{{$t('group.import.teachers')}}</th>
                </tr>
                <tr v-for="(group, index) in result.result">
                    <td>{{index}}</td>
                    <td>
                        <span style="display: block;" v-for="student in group.students">{{student.full_name}}</span>
                    </td>
                    <td>
                        <span style="display: block;" v-for="student in group.students">{{student.email}}</span>
                    </td>
                    <td v-if="settings.teacher_email">
                        <span style="display: block;" v-for="teacher in group.teachers">{{teacher.full_name}}</span>
                    </td>
                    <td v-if="settings.teacher_email">
                        <span style="display: block;" v-for="teacher in group.teachers">{{teacher.email}}</span>
                    </td>
                </tr>
            </table>

            <button class="btn btn-primary float-left" @click="goBack">Terug</button>

            <button class="btn btn-primary float-right" @click="startImport">Start import</button>
        </div>

        <div v-else>
            <p>{{$t('group.import.there_are_one_or_more_problems_importing_this_list')}}</p>

            <ul>
                <li v-for="error in result.errors">{{error}}</li>
            </ul>

            <button class="btn btn-primary float-left" @click="goBack">{{$t('group.import.back')}}</button>
        </div>

    </div>

</template>

<script>

    export default {
        name: "GroupImportComponent",
        props: ['settings','groupId', 'result'], 
        data () {
            return {
            }
        },
        methods: {
            startImport() {
                this.alert.saving();

                window.open(this.routes.baseUrl() + '/group/' + this.groupId + '/import/' + this.settings.id + '/start','_blank');

                window.location.href = this.routes.baseUrl() + '/group/' + this.groupId;
            },
            goBack() {
                window.location.href = this.routes.baseUrl() + '/group/' + this.groupId + '/import/' + this.settings.id + '/settings';
            }
        }
    }
</script>

<style scoped>

</style>